import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";

export default function SelectPage() {
  const [cookies] = useCookies(["uuid"]);
  const [uid, setUID] = useState(0);
  const [email, setEmail] = useState("");
  const [nickname, setNickname] = useState("");
  const [processingKey, setProcessingKey] = useState(null);
  const [isApiModalOpen, setIsApiModalOpen] = useState(false);
  const [secondUid, setSecondUid] = useState("");
  const [secondUidError, setSecondUidError] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [apiPassword, setApiPassword] = useState("");
  const [apiSaving, setApiSaving] = useState(false);

  const sanitizeNoSpace = (value) => value.replace(/\s+/g, "");
  const sanitizeDigits = (value) => value.replace(/\D+/g, "");
  const isValidSecondUid = (value) => /^\d{10}$/.test(value);

  useEffect(() => {
    if (!cookies.uuid) {
      alert("로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.");
      window.location.href = `/LoginAts`;
      return;
    }
    fetchUserInfo(cookies.uuid);
  }, [cookies.uuid]);

  const fetchUserInfo = async (uuid) => {
    try {
      const response = await fetch(`/SetPage/user?uuid=${uuid}`);
      if (!response.ok) {
        throw new Error("서버 응답 실패");
      }
      const data = await response.json();
      const user = data[0];
      if (!user) {
        throw new Error("사용자 없음");
      }
      setUID(user.uid);
      setEmail(user.email || "");
      setNickname(user.nickname);
    } catch (error) {
      alert("로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.");
      window.location.href = `/LoginAts`;
    }
  };

  const handleVersionSelect = async (option) => {
    if (!uid || option.disabled || processingKey) {
      return;
    }
    setProcessingKey(option.key);
    try {
      const response = await fetch(option.endpoint, { credentials: "same-origin" });
      if (!response.ok) {
        throw new Error("네트워크 오류");
      }
      const result = await response.json();
      if (result?.message && result.message !== "ok") {
        alert(result.message);
        return;
      }
      if (option.successMessage) {
        alert(option.successMessage);
      }
      window.location.href = option.redirect;
    } catch (error) {
      console.error(error);
      alert("서비스 연결에 실패했습니다. 잠시 후 다시 시도해주세요.");
    } finally {
      setProcessingKey(null);
    }
  };

  const liveStrategies = [
    // {
    //   key: "kp",
    //   label: "KinPoint",
    //   subtitle: "Orderflow · Momentum",
    //   description: "KP 시그널 기반으로 급변 추세를 민첩하게 포착합니다.",
    //   badge: "LIVE",
    //   icon: "🎯",
    //   endpoint: "/kpversion_selected",
    //   redirect: "/SetPageKp",
    //   successMessage: "Move to KP version page",
    //   accent: "#63f7ff",
    // },
    {
      key: "wz",
      label: "Wizard",
      subtitle: "Delta hedge · Swing",
      description: "변동성 회귀와 리스크 헷지를 동시에 관리하는 하이브리드 전략.",
      badge: "LIVE",
      icon: "🧙‍♂️",
      endpoint: "/wzversion_selected",
      redirect: "/SetPageWz",
      successMessage: "Move to WZ version page",
      accent: "#8c7bff",
    },
    {
      key: "hedge",
      label: "Hedge",
      subtitle: "Multi leg · Risk off",
      description: "포트폴리오 전반을 감싸는 안정적인 쿨다운·헷지 버전입니다.",
      badge: "LIVE",
      icon: "🛡️",
      endpoint: "/hedgeversion_selected",
      redirect: "/SetPageHedge",
      successMessage: "Move to Hedge version page",
      accent: "#5cd6a8",
    },
    {
      key: "circle",
      label: "Circle",
      subtitle: "Loop rebalance",
      description: "루프형 분산 전략으로 완만한 수익곡선을 설계합니다.",
      badge: "LIVE",
      icon: "⭕",
      endpoint: "/circleversion_selected",
      redirect: "/SetPageCircle",
      successMessage: "Move to Circle version page",
      accent: "#f7a35c",
    },
    {
      key: "hedgePro",
      label: "Hedge Pro",
      subtitle: "Multi leg · Risk off pro",
      description: "Hedge 모드의 더 공격적인 리밸런싱을 제공합니다.",
      badge: "LIVE",
      icon: "🚀",
      endpoint: "/circleproversion_selected",
      redirect: "/SetPageCirclePro",
      successMessage: "Move to Hedge Pro version page",
      accent: "#ff7eb6",
    },
    {
      key: "circlePro",
      label: "Circle Pro Supreme",
      subtitle: "Loop rebalance pro",
      description: "Circle Pro Supreme 모드의 정밀 파라미터로 더 공격적인 리밸런싱을 제공합니다.",
      badge: "LIVE",
      icon: "🛡️",
      endpoint: "/csupremeversion_selected",
      redirect: "/SetPageCSupreme",
      successMessage: "Move to Circle Pro Supreme version page",
      accent: "#63f7ff",
    },
    {
      key: "cplus",
      label: "Circle Pro Plus",
      subtitle: "Loop rebalance plus",
      description: "Circle Plus (Circle + Circle Pro) 장점만을 취합한 버전입니다.",
      badge: "LIVE",
      icon: "💥",
      endpoint: "/cplusversion_selected",
      redirect: "/SetPageCPlus",
      successMessage: "Move to Circle Plus version page",
      accent: "#c8ff00",
    },
    {
      key: "hold",
      label: "Hold",
      subtitle: "Hold strategy",
      description: "Hold 모드로 손실율을 최소화 하는 전략으로 안정성을 제공합니다.",
      badge: "LIVE",
      icon: "🎛️",
      endpoint: "/holdversion_selected",
      redirect: "/SetPageHold",
      successMessage: "Move to Hold version page",
      accent: "#ff6b6b",
    },
    {
      key: "escape",
      label: "Escape",
      subtitle: "Oneway · Dual · Grid",
      description: "Hold와 분리된 탈출 전용 프로그램. 원웨이 이스케이프부터 단계적으로 제공합니다.",
      badge: "LIVE",
      icon: "🚪",
      endpoint: "/escapeversion_selected",
      redirect: "/SetPageEscape",
      successMessage: "Move to Escape version page",
      accent: "#4ecdc4",
    },
    {
      key: "band",
      label: "Band",
      subtitle: "Band · Hedge range",
      description: "헷지 기준봉 N봉 고저가를 활용하는 Band 전략입니다.",
      badge: "LIVE",
      icon: "📊",
      endpoint: "/bandversion_selected",
      redirect: "/SetPageBand",
      successMessage: "Move to Band version page",
      accent: "#6b9fff",
    },
    {
      key: "meme",
      label: "Meme",
      subtitle: "Funding · Scan · Grid",
      description: "펀딩·등락 스캔과 10단 그리드로 롱/숏을 각각 독립 운용합니다.",
      badge: "LIVE",
      icon: "🪙",
      endpoint: "/memeversion_selected",
      redirect: "/SetPageMeme",
      successMessage: "Move to Meme version page",
      accent: "#22d3ee",
    },
  ];

  const comingSoonStrategies = [
    {
      key: "web",
      label: "Web",
      subtitle: "Dashboard",
      description: "브라우저에서 즉시 제어 가능한 경량 버전.",
      badge: "SOON",
      icon: "🧭",
      endpoint: "/webversion_selected",
      redirect: "/SetPage",
      successMessage: "Move to web version page",
      accent: "#5ab4ff",
      disabled: true,
    },
    {
      key: "hook",
      label: "Hook",
      subtitle: "Smart hook",
      description: "실시간 웹훅 연동을 위한 자동진입 모듈.",
      badge: "SOON",
      icon: "🪝",
      endpoint: "/hookversion_selected",
      redirect: "/SetPageHook",
      successMessage: "Move to Hook version page",
      accent: "#ffd166",
      disabled: true,
    },
    {
      key: "leverage",
      label: "Leverage",
      subtitle: "Cross leverage",
      description: "고배율 프리셋과 자금관리 툴을 담은 버전입니다.",
      badge: "SOON",
      icon: "⚡",
      endpoint: "/leverageversion_selected",
      redirect: "/SetPageLeverage",
      successMessage: "Move to Leverage version page",
      accent: "#ff8fb1",
      disabled: true,
    },
    {
      key: "royal",
      label: "Royal",
      subtitle: "Premium quant",
      description: "시즌 한정 VIP 전략 팩.",
      badge: "SOON",
      icon: "👑",
      endpoint: "/royalversion_selected",
      redirect: "/SetPageRoyal",
      successMessage: "Move to Royal version page",
      accent: "#fdd85d",
      disabled: true,
    },
    {
      key: "burst",
      label: "Burst",
      subtitle: "Scalping",
      description: "초단타 집중 버전, 탁월한 응답 속도를 제공합니다.",
      badge: "SOON",
      icon: "💥",
      endpoint: "/burstversion_selected",
      redirect: "/SetPageBurst",
      successMessage: "Move to Burst version page",
      accent: "#b388ff",
      disabled: true,
    },
    {
      key: "pin",
      label: "Pin",
      subtitle: "Signal pin",
      description: "맞춤형 시그널 핀을 위한 실험실 버전.",
      badge: "SOON",
      icon: "📌",
      endpoint: "/pinversion_selected",
      redirect: "/SetPagePin",
      successMessage: "Move to Pin version page",
      accent: "#6efacc",
      disabled: true,
    },
  ];

  const isUserReady = Boolean(uid);

  const openApiModal = () => {
    setIsApiModalOpen(true);
  };

  const closeApiModal = () => {
    setIsApiModalOpen(false);
    setSecondUidError("");
  };

  const handleApiSave = async () => {
    if (apiSaving) {
      return;
    }
    if (!uid) {
      alert("사용자 정보를 불러오지 못했습니다. 다시 로그인해주세요.");
      return;
    }
    if (!secondUid.trim() || !apiKey.trim() || !secretKey.trim() || !apiPassword.trim()) {
      alert("2nd UID, API Key, Secret Key, API Password를 모두 입력해주세요.");
      return;
    }
    if (!isValidSecondUid(secondUid.trim())) {
      setSecondUidError("2nd UID는 10자리 숫자로 입력해주세요.");
      alert("2nd UID는 10자리 숫자로 입력해주세요.");
      return;
    }

    setApiSaving(true);

    try {
      const response = await fetch("/signup/members_second", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          uid, // 현재 사용자 uid를 함께 보내 동일 uid인 경우 덮어쓰기 허용
          overwriteIfSameUid: true,
          uid_2: secondUid.trim(),
          api: apiKey.trim(),
          secretkey: secretKey.trim(),
          api_pw: apiPassword.trim(),
        }),
      });

      const text = await response.text();
      let payload;
      try {
        payload = JSON.parse(text);
      } catch {
        payload = { message: text };
      }

      if (!response.ok) {
        throw new Error(payload.message || text || "2nd UID 저장 중 오류가 발생했습니다.");
      }

      // 서버가 ok 또는 same-uid overwrite 케이스를 success로 리턴
      const isSuccess = payload?.ok || payload?.overwritten || payload?.updated;
      if (isSuccess) {
        alert(payload.message || "2nd UID가 등록되었습니다.");
        setSecondUid("");
        setApiKey("");
        setSecretKey("");
        setApiPassword("");
        setSecondUidError("");
        closeApiModal();
        return;
      }

      // uid가 다른 중복 케이스만 사용자에게 노출
      alert(payload.message || text || "이미 등록된 정보가 있습니다.");
    } catch (error) {
      console.error(error);
      alert(error.message || "2nd UID 저장에 실패했습니다. 잠시 후 다시 시도해주세요.");
    } finally {
      setApiSaving(false);
    }
  };

  const renderStrategyButton = (option) => {
    const isBusy = processingKey === option.key;
    const isDisabled = option.disabled || !isUserReady || isBusy;
    return (
      <button
        key={option.key}
        type="button"
        className={`select-card${isDisabled ? " select-card--disabled" : ""}${
          isBusy ? " select-card--loading" : ""
        }`}
        style={{ "--card-accent": option.accent }}
        onClick={() => handleVersionSelect(option)}
        disabled={isDisabled}
      >
        <div className="select-card__top">
          <span className="select-card__badge">{option.badge}</span>
          <span className="select-card__icon" aria-hidden="true">
            {option.icon}
          </span>
        </div>
        <div className="select-card__body">
          <div>
            <p className="select-card__title">{option.label}</p>
            <p className="select-card__subtitle">{option.subtitle}</p>
          </div>
          <p className="select-card__description">{option.description}</p>
        </div>
        <div className="select-card__footer">
          {isDisabled && option.disabled ? (
            <span className="select-card__status">Coming soon</span>
          ) : (
            <span className="select-card__cta">
              {isBusy ? "연결 중..." : "지금 접속"}
            </span>
          )}
        </div>
      </button>
    );
  };

  return (
    <main className="select-page">
      <div className="select-page__glare" aria-hidden="true" />
      <section className="select-page__panel">
        <header className="select-page__header">
          <p className="select-page__eyebrow">Bitgenstone auto trade system</p>
          <h1 className="select-page__title">Automation cockpit</h1>
          <p className="select-page__subtitle">
            실거래에서 검증된 전략을 선택해 곧바로 실행하세요.
          </p>
          <p className="select-page__subtitle">
            모든 버전은 Bitget 환경에 최적화되어 있습니다.
          </p>
          <div className="select-page__user-card">
            <span className="select-page__user-id">
              UID {isUserReady ? uid : "Loading..."}
            </span>
            <span className="select-page__user-name">
              {nickname ? `${nickname}님 환영합니다` : "사용자 정보를 불러오는 중"}
            </span>
            <button
              type="button"
              className="select-page__action-btn"
              onClick={openApiModal}
            >
              2nd UID 추가
            </button>
          </div>
        </header>

        <section className="select-section">
          <div className="select-section__head">
            <div>
              <p className="select-section__eyebrow">LIVE STRATEGIES</p>
              <h2 className="select-section__title">지금 바로 실행 가능한 버전</h2>
            </div>
            <p className="select-section__meta">Bitget · 안정 검증 완료</p>
          </div>
          <div className="select-grid">{liveStrategies.map(renderStrategyButton)}</div>
        </section>

        <section className="select-section">
          <div className="select-section__head">
            <div>
              <p className="select-section__eyebrow">LAB UPDATE</p>
              <h2 className="select-section__title">곧 다시 만나요</h2>
            </div>
            <p className="select-section__meta">사전 예약 및 커스텀 준비 중</p>
          </div>
          <div className="select-grid">
            {comingSoonStrategies.map(renderStrategyButton)}
          </div>
        </section>
      </section>

      {isApiModalOpen && (
        <div className="select-page__modal-backdrop" role="presentation">
          <div
            className="select-page__modal"
            role="dialog"
            aria-modal="true"
            aria-label="2nd UID API 등록"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="select-page__modal-header">
              <h3>2nd UID API 등록</h3>
              <button type="button" className="select-page__modal-close" onClick={closeApiModal} aria-label="Close">
                ×
              </button>
            </div>
            <div className="select-page__modal-body">
              <label className="select-page__modal-field">
                <span>2nd UID</span>
                <input
                  type="text"
                  value={secondUid}
                  onChange={(e) => {
                    const nextValue = sanitizeDigits(e.target.value);
                    setSecondUid(nextValue);
                    setSecondUidError("");
                  }}
                  placeholder="2nd UID를 입력하세요"
                  autoComplete="off"
                  inputMode="numeric"
                  aria-invalid={Boolean(secondUidError)}
                  aria-describedby={secondUidError ? "second-uid-error" : undefined}
                />
                {secondUidError && (
                  <small
                    id="second-uid-error"
                    style={{ color: "#ff5c5c", fontSize: "12px", marginTop: "6px", display: "block" }}
                  >
                    {secondUidError}
                  </small>
                )}
              </label>
              <label className="select-page__modal-field">
                <span>API Key</span>
                <input
                  type="text"
                  value={apiKey}
                  onChange={(e) => setApiKey(sanitizeNoSpace(e.target.value))}
                  placeholder="API Key를 입력하세요"
                  autoComplete="off"
                />
              </label>
              <label className="select-page__modal-field">
                <span>Secret Key</span>
                <input
                  type="text"
                  value={secretKey}
                  onChange={(e) => setSecretKey(sanitizeNoSpace(e.target.value))}
                  placeholder="Secret Key를 입력하세요"
                  autoComplete="off"
                />
              </label>
              <label className="select-page__modal-field">
                <span>API Password</span>
                <input
                  type="text"
                  value={apiPassword}
                  onChange={(e) => setApiPassword(sanitizeNoSpace(e.target.value))}
                  placeholder="API Password를 입력하세요"
                  autoComplete="new-password"
                />
              </label>
            </div>
            <div className="select-page__modal-actions">
              <button type="button" className="select-page__modal-cancel" onClick={closeApiModal}>
                취소
              </button>
              <button type="button" className="select-page__modal-save" onClick={handleApiSave}>
                {apiSaving ? "저장 중..." : "저장"}
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}






